enum PredictedFlowDownloadReportTypesEnum {
  pdf = 'pdf',
  spreadsheet = 'spreadsheet',
}

export default PredictedFlowDownloadReportTypesEnum;
